<script setup>
import { computed } from 'vue'
import { useTimestamp } from '@vueuse/core'

const props = defineProps({
  lastSeenAt: {
    type: [Number, String],
    default: null
  }
})

const now = useTimestamp({ interval: 1000 })

const lastSeenMinutes = computed(() => {
  const at = Number(props.lastSeenAt)

  if (!Number.isFinite(at) || at <= 0) {
    return null
  }

  return Math.max(Math.floor((now.value / 1000 - at) / 60), 1)
})

const isLastSeenRecently = computed(() => (
  lastSeenMinutes.value !== null && lastSeenMinutes.value < 15
))

const lastSeenTime = computed(() => {
  const minutes = lastSeenMinutes.value

  if (minutes === null) {
    return ''
  }

  let value = minutes
  let unit = 'm'

  if (minutes >= 24 * 60) {
    value = Math.floor(minutes / (24 * 60))
    unit = 'd'
  } else if (minutes >= 60) {
    value = Math.floor(minutes / 60)
    unit = 'h'
  }

  return `${value}${unit}`
})
</script>

<template>
  <span
    v-if="lastSeenTime"
    class="flex items-center gap-1 whitespace-nowrap text-xs text-gray-500 font-semibold">
    <InlineSvg
      :src="require('@/assets/svg/regular/clock-two-thirty.svg')"
      class="shrink-0 w-3 h-3"/>

    {{ isLastSeenRecently
      ? $t('creator.last_seen_recently')
      : $t('creator.last_seen', { time: lastSeenTime }) }}
  </span>
</template>
